<template>
    
    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        <!-- SIDEBAR -->
        <SidebarBody/>

        <div class="hp-main-layout" style="overflow-x: hidden;">

            <!-- HEADER -->
            <HeaderBody/>

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content no-pad">


                <div class="row mb-32 gy-18 dash-top" >

                    <div class="col-12">

                        <div class="row g-32">

                            <div class="col-12 col-xl-12">

                                <h2 class="dd-none" style="margin-top: -70px;"></h2>
                                

                                <div class="row gy-0">

                                    <div class="col-12">

                                        <div class="card hp-card-6">

                                            <img :src="profileBack" alt="" style="width: 100%;  object-fit: cover; " class="profB">

                                            <div class="card-body" style="margin-top: -60px;">
                                                <div class="d-flex justify-content-center align-items-center " style="width: 100%; flex-direction: column;">

                                                    <div class="d-flex justify-content-center align-items-center " style="flex-direction: column;">

                                                        <img class="profIm" :src="profilePic" alt="" style="border-radius: 50%;  object-fit: cover; border-color: #b2bec3; border-width: 1px; border-style: solid; margin-bottom: 10px;">

                                                        <h5 style="text-align: center; width: 100%;">{{ fullName }}</h5>
                                                        <p  class="hp-p1-body" style="margin-top: -20px; text-align: center; width: 100%;">@{{ userName }}</p>

                                                    </div>

                                                    <div class="col-12">
                                                        <div class="row">
                                                            <p class="hp-p1-body suxtet">{{ subDescription }}</p>
                                                        </div>
                                                    </div>

                                                    <div class="col-12">
                                                        <div class="row">
                                                            
                                                        </div>
                                                    </div>

                                                    <div class="divider mt-18 mb-24"></div>

                                                    <!-- PRICES -->
                                                    <div class="col-12 col-xl-12 mt-18">

                                                        <div class="row align-items-start justify-content-center gx-4 mx-0" style="width: 100%;">

                                                            <div class="col-12 col-xl-3  hp-pricing-item p-24 mx-18 mb-24 borde rounded " style="background-color: #D7C0A21a; border-color: #574630; border-width: 2px; border-style: dashed; ">
                                                                <div>
                                                                    <div class="row justify-content-between mb-8 mb-sm-32">

                                                                        <div class="col pe-0">
                                                                            <h5 class="mb-0 hp-pricing-item-title" style="color: #574630;">Bronze</h5>
                                                                            <p class="hp-pricing-item-subtitle hp-caption text-black-60 mb-0">For New Fans</p>
                                                                        </div>

                                                                    </div>

                                                                    <h1 class="mm-none" style="font-size: 38px; margin-bottom: -5px"> &#8358; {{ bundle1M.toLocaleString("en-US") }} </h1>
                                                                    <h1 class="dd-none" style="font-size: 38px; margin-top: 40px; margin-bottom: -10px"> &#8358; {{ bundle1M.toLocaleString("en-US") }} </h1>

                                                                    <p class=" hp-pricing-item-billed hp-caption mt-24 mt-sm-4 mb-0 text-black-60" >
                                                                        <span  class="hp-pricing-billed-active">per month</span>
                                                                        
                                                                    </p>

                                                                    

                                                                    <div class="divider mt-18 mb-16"></div>

                                                                    <ul class="mt-24 ">

                                                                        <li class="hp-pricing-item-list d-flex align-items-center mt-8">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM6.99992 12.3334C8.41441 12.3334 9.77096 11.7715 10.7712 10.7713C11.7713 9.77108 12.3333 8.41453 12.3333 7.00004C12.3333 5.58555 11.7713 4.229 10.7712 3.2288C9.77096 2.22861 8.41441 1.66671 6.99992 1.66671C5.58543 1.66671 4.22888 2.22861 3.22868 3.2288C2.22849 4.229 1.66659 5.58555 1.66659 7.00004C1.66659 8.41453 2.22849 9.77108 3.22868 10.7713C4.22888 11.7715 5.58543 12.3334 6.99992 12.3334ZM6.33525 9.66671L3.50659 6.83804L4.44925 5.89537L6.33525 7.78137L10.1059 4.01004L11.0493 4.95271L6.33525 9.66671Z" fill="#000000"></path>
                                                                            </svg>
                                                                            <span class="d-block ms-8 hp-caption fw-normal hp-text-color-dark-0">Exclusive Content Access</span>
                                                                        </li>

                                                                        <li class="hp-pricing-item-list d-flex align-items-center mt-8">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM6.99992 12.3334C8.41441 12.3334 9.77096 11.7715 10.7712 10.7713C11.7713 9.77108 12.3333 8.41453 12.3333 7.00004C12.3333 5.58555 11.7713 4.229 10.7712 3.2288C9.77096 2.22861 8.41441 1.66671 6.99992 1.66671C5.58543 1.66671 4.22888 2.22861 3.22868 3.2288C2.22849 4.229 1.66659 5.58555 1.66659 7.00004C1.66659 8.41453 2.22849 9.77108 3.22868 10.7713C4.22888 11.7715 5.58543 12.3334 6.99992 12.3334ZM6.33525 9.66671L3.50659 6.83804L4.44925 5.89537L6.33525 7.78137L10.1059 4.01004L11.0493 4.95271L6.33525 9.66671Z" fill="#000000"></path>
                                                                            </svg>
                                                                            <span class="d-block ms-8 hp-caption fw-normal hp-text-color-dark-0">Direct Messages</span>
                                                                        </li>

                                                                        <li class="hp-pricing-item-list d-flex align-items-center mt-8">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM6.99992 12.3334C8.41441 12.3334 9.77096 11.7715 10.7712 10.7713C11.7713 9.77108 12.3333 8.41453 12.3333 7.00004C12.3333 5.58555 11.7713 4.229 10.7712 3.2288C9.77096 2.22861 8.41441 1.66671 6.99992 1.66671C5.58543 1.66671 4.22888 2.22861 3.22868 3.2288C2.22849 4.229 1.66659 5.58555 1.66659 7.00004C1.66659 8.41453 2.22849 9.77108 3.22868 10.7713C4.22888 11.7715 5.58543 12.3334 6.99992 12.3334ZM6.33525 9.66671L3.50659 6.83804L4.44925 5.89537L6.33525 7.78137L10.1059 4.01004L11.0493 4.95271L6.33525 9.66671Z" fill="#000000"></path>
                                                                            </svg>
                                                                            <span class="d-block ms-8 hp-caption fw-normal hp-text-color-dark-0">Early Bird Alerts</span>
                                                                        </li>

                                                                        <li class="hp-pricing-item-list d-flex align-items-center mt-8">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM6.99992 12.3334C8.41441 12.3334 9.77096 11.7715 10.7712 10.7713C11.7713 9.77108 12.3333 8.41453 12.3333 7.00004C12.3333 5.58555 11.7713 4.229 10.7712 3.2288C9.77096 2.22861 8.41441 1.66671 6.99992 1.66671C5.58543 1.66671 4.22888 2.22861 3.22868 3.2288C2.22849 4.229 1.66659 5.58555 1.66659 7.00004C1.66659 8.41453 2.22849 9.77108 3.22868 10.7713C4.22888 11.7715 5.58543 12.3334 6.99992 12.3334ZM6.33525 9.66671L3.50659 6.83804L4.44925 5.89537L6.33525 7.78137L10.1059 4.01004L11.0493 4.95271L6.33525 9.66671Z" fill="#000000"></path>
                                                                            </svg>
                                                                            <span class="d-block ms-8 hp-caption fw-normal hp-text-color-dark-0">Commenting Privileges</span>
                                                                        </li>

                                                                    </ul>

                                                                    
                                                                </div>

                                                                <button @click="subClick('Bronze', bundle1, 30)" type="button" class="btn btn-primary w-100 mt-32" style="background-color: #574630 !important;">
                                                                    <span style="text-align: start; width: 100%;">1 month</span>
                                                                    <span style="text-align: end; width: 100%;">&#8358; {{ bundle1D }}</span>
                                                                </button>
                                                            </div>

                                                            <div class="col-12 col-xl-3  hp-pricing-item p-24 mx-18 mb-24 borde rounded " style="background-color: #C9C9CA1a; border-color: #838996; border-width: 2px; border-style: dashed; ">
                                                                <div>
                                                                    <div class="row justify-content-between mb-8 mb-sm-32">

                                                                        <div class="col pe-0">
                                                                            <h5 class="mb-0 hp-pricing-item-title" style="color: #696969;">Silver</h5>
                                                                            <p class="hp-pricing-item-subtitle hp-caption text-black-60 mb-0">For Loyal Fans</p>
                                                                        </div>

                                                                    </div>

                                                                    <h1 class="mm-none" style="font-size: 38px; margin-bottom: -5px"> &#8358; {{ bundle2M.toLocaleString("en-US") }} </h1>
                                                                    <h1 class="dd-none" style="font-size: 38px; margin-top: 40px; margin-bottom: -10px"> &#8358; {{ bundle2M.toLocaleString("en-US") }} </h1>

                                                                    <p class=" hp-pricing-item-billed hp-caption mt-24 mt-sm-4 mb-0 text-black-60" >
                                                                        <span  class="hp-pricing-billed-active">per month</span>
                                                                        
                                                                    </p>

                                                                    <div class="divider mt-18 mb-16"></div>

                                                                    <ul class="mt-24 ">

                                                                        <li class="hp-pricing-item-list d-flex align-items-center mt-8">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM6.99992 12.3334C8.41441 12.3334 9.77096 11.7715 10.7712 10.7713C11.7713 9.77108 12.3333 8.41453 12.3333 7.00004C12.3333 5.58555 11.7713 4.229 10.7712 3.2288C9.77096 2.22861 8.41441 1.66671 6.99992 1.66671C5.58543 1.66671 4.22888 2.22861 3.22868 3.2288C2.22849 4.229 1.66659 5.58555 1.66659 7.00004C1.66659 8.41453 2.22849 9.77108 3.22868 10.7713C4.22888 11.7715 5.58543 12.3334 6.99992 12.3334ZM6.33525 9.66671L3.50659 6.83804L4.44925 5.89537L6.33525 7.78137L10.1059 4.01004L11.0493 4.95271L6.33525 9.66671Z" fill="#000000"></path>
                                                                            </svg>
                                                                            <span class="d-block ms-8 hp-caption fw-normal hp-text-color-dark-0">All Perks From Bronze </span>
                                                                        </li>

                                                                        <li class="hp-pricing-item-list d-flex align-items-center mt-8">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM6.99992 12.3334C8.41441 12.3334 9.77096 11.7715 10.7712 10.7713C11.7713 9.77108 12.3333 8.41453 12.3333 7.00004C12.3333 5.58555 11.7713 4.229 10.7712 3.2288C9.77096 2.22861 8.41441 1.66671 6.99992 1.66671C5.58543 1.66671 4.22888 2.22861 3.22868 3.2288C2.22849 4.229 1.66659 5.58555 1.66659 7.00004C1.66659 8.41453 2.22849 9.77108 3.22868 10.7713C4.22888 11.7715 5.58543 12.3334 6.99992 12.3334ZM6.33525 9.66671L3.50659 6.83804L4.44925 5.89537L6.33525 7.78137L10.1059 4.01004L11.0493 4.95271L6.33525 9.66671Z" fill="#000000"></path>
                                                                            </svg>
                                                                            <span class="d-block ms-8 hp-caption fw-normal hp-text-color-dark-0">Extended Live Streams</span>
                                                                        </li>

                                                                        <li class="hp-pricing-item-list d-flex align-items-center mt-8">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM6.99992 12.3334C8.41441 12.3334 9.77096 11.7715 10.7712 10.7713C11.7713 9.77108 12.3333 8.41453 12.3333 7.00004C12.3333 5.58555 11.7713 4.229 10.7712 3.2288C9.77096 2.22861 8.41441 1.66671 6.99992 1.66671C5.58543 1.66671 4.22888 2.22861 3.22868 3.2288C2.22849 4.229 1.66659 5.58555 1.66659 7.00004C1.66659 8.41453 2.22849 9.77108 3.22868 10.7713C4.22888 11.7715 5.58543 12.3334 6.99992 12.3334ZM6.33525 9.66671L3.50659 6.83804L4.44925 5.89537L6.33525 7.78137L10.1059 4.01004L11.0493 4.95271L6.33525 9.66671Z" fill="#000000"></path>
                                                                            </svg>
                                                                            <span class="d-block ms-8 hp-caption fw-normal hp-text-color-dark-0">Early Access to Content</span>
                                                                        </li>

                                                                        <li class="hp-pricing-item-list d-flex align-items-center mt-8">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM6.99992 12.3334C8.41441 12.3334 9.77096 11.7715 10.7712 10.7713C11.7713 9.77108 12.3333 8.41453 12.3333 7.00004C12.3333 5.58555 11.7713 4.229 10.7712 3.2288C9.77096 2.22861 8.41441 1.66671 6.99992 1.66671C5.58543 1.66671 4.22888 2.22861 3.22868 3.2288C2.22849 4.229 1.66659 5.58555 1.66659 7.00004C1.66659 8.41453 2.22849 9.77108 3.22868 10.7713C4.22888 11.7715 5.58543 12.3334 6.99992 12.3334ZM6.33525 9.66671L3.50659 6.83804L4.44925 5.89537L6.33525 7.78137L10.1059 4.01004L11.0493 4.95271L6.33525 9.66671Z" fill="#000000"></path>
                                                                            </svg>
                                                                            <span class="d-block ms-8 hp-caption fw-normal hp-text-color-dark-0">Personalized Content Requests</span>
                                                                        </li>

                                                                    </ul>

                                                                    
                                                                </div>

                                                                <button @click="subClick('Silver', bundle2, 90)" type="button" class="btn btn-primary w-100 mt-32" style="background-color: #838996 !important;">
                                                                    <span style="text-align: start; width: 100%;">3 months</span>
                                                                    <span style="text-align: end; width: 100%;">&#8358; {{ bundle2D }}</span>
                                                                </button>
                                                            </div>

                                                            <div class="col-12 col-xl-3  hp-pricing-item p-24 mx-18 mb-24 borde rounded " style="background-color: #f5f5dc33; border-color: #CCB429; border-width: 2px; border-style: dashed; ">
                                                                <div>
                                                                    <div class="row justify-content-between mb-8 mb-sm-32">

                                                                        <div class="col pe-0">
                                                                            <h5 class="mb-0 hp-pricing-item-title" style="color: #CCB429;">Gold</h5>
                                                                            <p class="hp-pricing-item-subtitle hp-caption text-black-60 mb-0">For VIP Super Fans</p>
                                                                        </div>

                                                                    </div>

                                                                    <h1 class="mm-none" style="font-size: 38px; margin-bottom: -5px"> &#8358; {{ bundle3M.toLocaleString("en-US") }} </h1>
                                                                    <h1 class="dd-none" style="font-size: 38px; margin-top: 40px; margin-bottom: -10px"> &#8358; {{ bundle3M.toLocaleString("en-US") }} </h1>

                                                                    <p class=" hp-pricing-item-billed hp-caption mt-24 mt-sm-4 mb-0 text-black-60" >
                                                                        <span  class="hp-pricing-billed-active">per month</span>
                                                                        
                                                                    </p>

                                                                    <div class="divider mt-18 mb-16"></div>

                                                                    <ul class="mt-24 ">

                                                                        <li class="hp-pricing-item-list d-flex align-items-center mt-8">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM6.99992 12.3334C8.41441 12.3334 9.77096 11.7715 10.7712 10.7713C11.7713 9.77108 12.3333 8.41453 12.3333 7.00004C12.3333 5.58555 11.7713 4.229 10.7712 3.2288C9.77096 2.22861 8.41441 1.66671 6.99992 1.66671C5.58543 1.66671 4.22888 2.22861 3.22868 3.2288C2.22849 4.229 1.66659 5.58555 1.66659 7.00004C1.66659 8.41453 2.22849 9.77108 3.22868 10.7713C4.22888 11.7715 5.58543 12.3334 6.99992 12.3334ZM6.33525 9.66671L3.50659 6.83804L4.44925 5.89537L6.33525 7.78137L10.1059 4.01004L11.0493 4.95271L6.33525 9.66671Z" fill="#000000"></path>
                                                                            </svg>
                                                                            <span class="d-block ms-8 hp-caption fw-normal hp-text-color-dark-0">All Perks From Bronze and Silver</span>
                                                                        </li>

                                                                        <li class="hp-pricing-item-list d-flex align-items-center mt-8">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM6.99992 12.3334C8.41441 12.3334 9.77096 11.7715 10.7712 10.7713C11.7713 9.77108 12.3333 8.41453 12.3333 7.00004C12.3333 5.58555 11.7713 4.229 10.7712 3.2288C9.77096 2.22861 8.41441 1.66671 6.99992 1.66671C5.58543 1.66671 4.22888 2.22861 3.22868 3.2288C2.22849 4.229 1.66659 5.58555 1.66659 7.00004C1.66659 8.41453 2.22849 9.77108 3.22868 10.7713C4.22888 11.7715 5.58543 12.3334 6.99992 12.3334ZM6.33525 9.66671L3.50659 6.83804L4.44925 5.89537L6.33525 7.78137L10.1059 4.01004L11.0493 4.95271L6.33525 9.66671Z" fill="#000000"></path>
                                                                            </svg>
                                                                            <span class="d-block ms-8 hp-caption fw-normal hp-text-color-dark-0">Exclusive VIP Content</span>
                                                                        </li>

                                                                        <li class="hp-pricing-item-list d-flex align-items-center mt-8">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM6.99992 12.3334C8.41441 12.3334 9.77096 11.7715 10.7712 10.7713C11.7713 9.77108 12.3333 8.41453 12.3333 7.00004C12.3333 5.58555 11.7713 4.229 10.7712 3.2288C9.77096 2.22861 8.41441 1.66671 6.99992 1.66671C5.58543 1.66671 4.22888 2.22861 3.22868 3.2288C2.22849 4.229 1.66659 5.58555 1.66659 7.00004C1.66659 8.41453 2.22849 9.77108 3.22868 10.7713C4.22888 11.7715 5.58543 12.3334 6.99992 12.3334ZM6.33525 9.66671L3.50659 6.83804L4.44925 5.89537L6.33525 7.78137L10.1059 4.01004L11.0493 4.95271L6.33525 9.66671Z" fill="#000000"></path>
                                                                            </svg>
                                                                            <span class="d-block ms-8 hp-caption fw-normal hp-text-color-dark-0">Priority Support</span>
                                                                        </li>

                                                                        <li class="hp-pricing-item-list d-flex align-items-center mt-8">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6.99992 13.6667C3.31792 13.6667 0.333252 10.682 0.333252 7.00004C0.333252 3.31804 3.31792 0.333374 6.99992 0.333374C10.6819 0.333374 13.6666 3.31804 13.6666 7.00004C13.6666 10.682 10.6819 13.6667 6.99992 13.6667ZM6.99992 12.3334C8.41441 12.3334 9.77096 11.7715 10.7712 10.7713C11.7713 9.77108 12.3333 8.41453 12.3333 7.00004C12.3333 5.58555 11.7713 4.229 10.7712 3.2288C9.77096 2.22861 8.41441 1.66671 6.99992 1.66671C5.58543 1.66671 4.22888 2.22861 3.22868 3.2288C2.22849 4.229 1.66659 5.58555 1.66659 7.00004C1.66659 8.41453 2.22849 9.77108 3.22868 10.7713C4.22888 11.7715 5.58543 12.3334 6.99992 12.3334ZM6.33525 9.66671L3.50659 6.83804L4.44925 5.89537L6.33525 7.78137L10.1059 4.01004L11.0493 4.95271L6.33525 9.66671Z" fill="#000000"></path>
                                                                            </svg>
                                                                            <span class="d-block ms-8 hp-caption fw-normal hp-text-color-dark-0">Recognition Badge</span>
                                                                        </li>

                                                                        

                                                                    </ul>

                                                                    
                                                                </div>

                                                                <button @click="subClick('Gold', bundle3, 180)" type="button" class="btn btn-primary w-100 mt-32" style="background-color: #CCB429 !important;">
                                                                    <span style="text-align: start; width: 100%;">6 months</span>
                                                                    <span style="text-align: end; width: 100%;">&#8358; {{ bundle3D }}</span>
                                                                </button>
                                                            </div>

                                            

                                                        </div>
                                                        
                                                    </div>

                                                    <div class="divider mt-18 mb-24"></div>

                                                    <button @click="goBack" class="btn btn-outline-danger">Close</button>

                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>
                            

                        </div>

                    </div>

                    
                </div>


                <!-- FOOTER -->
                <FooterBody/>

            </div>

        </div>

    </main>



    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>


    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px; ">
                <div class="card hp-card-4" >
                    <div class="card-body" >
                        <div class="row" >
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- CONFIRM SUB -->
        <div class="modal fade" id="confirmSub" tabindex="-1" aria-labelledby="confirmSubLabel" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h5 class="modal-title">Confirm subscription</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    

                    <div class="modal-body" style="margin-top: -20px;">

                        <p class="hp-p1-body" > Are you sure you want to subscribe to @{{ userName }} for {{ cDays }} days with <strong>&#8358;{{ cPrice }}</strong> </p>

                        <div class="mb-24" style="margin-top: 30px;">

                                <label for="displayName" class="form-label">Password</label>
                                <input type="password" placeholder="Your password" class="form-control" v-model="password">

                            </div>

                            <div class="divider mt-18 mb-16"></div>
                            

                            <div class="modal-footer">
                                <button class="btn btn-text" data-bs-dismiss="modal">Close</button>
                                <button class="btn btn-primary" data-bs-dismiss="modal" @click="subscribe">Confirm</button>
                            </div>

                        

                        

                        
                        
                    </div>

                    
                </div>
            </div>
        </div>


</template>

<style scoped>

    .shx{
        width: 1000px;   
    }

    .shm{
        max-width: 100%;
        max-height: 500px;
        object-fit: cover;
    }

    .no-pad{
        margin-top: -15px;
    }

    .profB{
        border-top-left-radius: 20px; 
        border-top-right-radius: 20px;
        height: 200px;
    }

    .profIm{
        width: 90px;
        height: 90px;
    }

    .suxtet{
        padding: 15px 150px 5px 150px; width: 100%; text-align: start;
    }

    @media only screen and (max-width: 666px){

        .suxtet{
            padding: 5px 10px 5px 10px; width: 100%; text-align: start;
        }

        .shx{
            width: 350px;
            
        }

        .shm{
            max-width: 100%;
            max-height: 700px;
            object-fit: cover;
        }

        .no-pad{
            margin: 0;
            padding: 0;
        }

        .profB{
            border-radius: 0px;
            height: 150px; 
        
        }

        .profIm{
            width: 70px;
            height: 70px;
        }

    }

</style>



<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import FooterBody from '@/components/FooterBody.vue';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, Timestamp, setDoc } from "firebase/firestore"; 
    import {getAuth, EmailAuthProvider, reauthenticateWithCredential} from "firebase/auth"
    import { db } from '@/firebase';
    import axios from 'axios';
    import { MD5 } from 'md5-js-tools';

    export default {

        components: {
            SidebarBody,
            HeaderBody,
            FooterBody,
        },

        data(){
            return{
                loadingText: "",
                successText: "",
                errorText: "",

                fullName: "",
                userName: "",
                email: "",
                profilePic: "",
                profileBack: "",
                subDescription: "",

                bundle1: "",
                bundle2: "",
                bundle3: "",

                bundle1M: "",
                bundle2M: "",
                bundle3M: "",

                bundle1D: "",
                bundle2D: "",
                bundle3D: "",

                userType: "",
                sexuality: "",

                cTier: "",
                cPrice: "",
                cDays: "",

                password: "",

                upline: "",
                uplineUserId: "",
                refCut: "",
                dateJoined: ""
            }
        },

        mounted(){

            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'Subscribe';

            this.getRefCut();
            this.getUserInfo();
        },

        methods:{

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go(-1);
            },

            goBack(){
                this.$router.go(-1);
            },

            round(num, decimals){
                return +(Math.round(num + "e" + decimals) + "e-" + decimals);
            },

            async getRefCut(){
                const userRef = doc(db, "AdminInfo", "info");
                const userSnap = await getDoc(userRef);
                let rc  = userSnap.data().refCut;
                this.refCut = Number(rc);

            },

            async getUserInfo(){
                this.loadingText = "Getting subscription info...";
                this.$refs.loadingModal.classList.add("bg-active");

                const userRef = doc(db, "Users", sessionStorage.getItem("otherId"));
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    
                    this.userType = userSnap.data().type;

                    this.fullName = userSnap.data().name;
                    this.userName = userSnap.data().displayId;
                    this.email = userSnap.data().email;
                    this.profilePic = userSnap.data().profilePic;
                    this.profileBack = userSnap.data().profileBackground;
                    this.userType = userSnap.data().type;
                    
                    this.bundle1 = userSnap.data().bundle1;
                    this.bundle2 = userSnap.data().bundle2;
                    this.bundle3 = userSnap.data().bundle3;

                    this.bundle1M = this.round(userSnap.data().bundle1, 0)
                    this.bundle2M = this.round(Number(userSnap.data().bundle2 / 3), 0)
                    this.bundle3M = this.round(Number(userSnap.data().bundle3 / 6), 0)

                    this.bundle1D = Number(userSnap.data().bundle1).toLocaleString("en-US");
                    this.bundle2D = Number(userSnap.data().bundle2).toLocaleString("en-US");
                    this.bundle3D = Number(userSnap.data().bundle3).toLocaleString("en-US");
                    this.subDescription = userSnap.data().subDescription;
                    this.upline = userSnap.data().upline;
                    this.sexuality = userSnap.data().sexuality;
                    this.dateJoined = userSnap.data().dateJoined.seconds;

                    const q = query(collection(db, "Users"), where("refCode", "==", this.upline));
                    const idSnapshot = await getDocs(q);
                    if(idSnapshot.docs.length > 0){
                        idSnapshot.forEach((doc) => {
                            this.uplineUserId = doc.id;
                        });

                    }

                    if(this.userType != "model"){
                        this.$router.push({name: 'home'});
                    }

                    
                }
                else{
                    this.errorText = "User does not exist";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    //this.$router.push({name: 'sign-in'});
                    return;
                }

                this.$refs.loadingModal.classList.remove("bg-active");
            },

            subClick(tier, price, days){

                this.cTier = tier;
                this.cPrice = price;
                this.cDays = days;

                $('#confirmSub').modal('show');

            },

            subscribe(){
                this.loadingText = "Authenticating...";
                this.$refs.loadingModal.classList.add("bg-active");

                if(this.password == ""){
                    this.errorText = "Please enter your password to proceed.";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                let passwordHash = MD5.generate(String(this.password));

                const auth = getAuth();

                const user = auth.currentUser;
                const credential = EmailAuthProvider.credential(
                sessionStorage.getItem("email"), passwordHash );

                reauthenticateWithCredential(user, credential)
                .then((result) => {
                    //password correct
                    this.subscribe2();

                })
                .catch((error) => {
                    console.log(error);
                    this.errorText = "Incorrect password...";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;

                });
            },

            async subscribe2() {

            let balance, newBalance, uFullname, uEmail, uProfilePic;

            const auth = getAuth();

            this.loadingText = "Subscribing to @" + this.userName + "...";

            //check balance
            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                balance = userSnap.data().balance;
                uFullname = userSnap.data().name;
                uProfilePic = userSnap.data().profilePic;
                uEmail = userSnap.data().email;

                if (balance < this.cPrice) {
                    this.errorText = "Insufficient balance. Please top up your account and try again.";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }
            }
            else {
                this.$router.push({ name: 'sign-in' });
                return;
            }

            let todaySecs = Timestamp.now().seconds;
            let durationSecs = this.cDays * 86400;
            let endDateSecs = todaySecs + durationSecs;

            //newBalance = balance - this.price;

            await updateDoc(userRef, {
                balance: increment(-this.cPrice),
            });

            //update model balance
            const modelRef = doc(db, "Users", sessionStorage.getItem("otherId"));
            await updateDoc(modelRef, {
                earnings: increment(this.cPrice),
                subBalance: increment(this.cPrice),
                fanCount: increment(1),
                fanCountN: increment(-1)
            });

            //update model fan list
            await setDoc(doc(db, "UserFans", sessionStorage.getItem("otherId"), "Fans", auth.currentUser.uid,), {
                price: this.cPrice,
                startDate: serverTimestamp(),
                duration: this.cDays,
                endDate: endDateSecs,
                status: "active",
                userId: auth.currentUser.uid,
                username: sessionStorage.getItem("userName"),
                fullName: uFullname,
                profilePic: uProfilePic,
                email: uEmail,
            });

            await setDoc(doc(db, "UserSubs", auth.currentUser.uid, "Subs", sessionStorage.getItem("otherId")), {
                price: this.cPrice,
                startDate: serverTimestamp(),
                duration: this.cDays,
                endDate: endDateSecs,
                status: "active",
                modelId: sessionStorage.getItem("otherId"),
                modelName: this.fullName,
                modelUserName: this.userName,
                modelProfilePic: this.profilePic,
                email: this.email,
            });

            let mSecs = new Date().getTime() / 1000;
            let transSecs = 10000000000 / mSecs;

            //update user transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Withdrawal",
                title: "Subscription",
                description: " Subscribed to @" + this.userName + " for " + this.cDays + " days",
                amount: this.cPrice,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: auth.currentUser.uid,
                fullName: this.fullName,
                username: this.userName,
                profilePic: this.profilePic,
            });

            //update model transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Deposit",
                title: "Subscription",
                description: "@" + sessionStorage.getItem("userName") + " subscribed to your account for " + this.cDays + " days",
                amount: this.cPrice,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: sessionStorage.getItem("otherId"),
                
                username: sessionStorage.getItem("userName"),
                fullName: sessionStorage.getItem("fullName"),
                profilePic: sessionStorage.getItem("profilePic"),

            });

            // NOTIFICATION
            if (sessionStorage.getItem("otherId") != auth.currentUser.uid) {

                const notiRef = doc(db, "Users", sessionStorage.getItem("otherId"));
                await updateDoc(notiRef, {
                    notiCount: increment(1),
                });

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs

                await addDoc(collection(db, "UserNoti"), {
                    category: "Subs",
                    description: "Subscribed to your content for " + this.cDays + " days at ₦" + this.cPrice,
                    ownerId: sessionStorage.getItem("otherId"),
                    userId: auth.currentUser.uid,
                    username: sessionStorage.getItem("userName"),
                    fullName: uFullname,
                    profilePic: uProfilePic,
                    email: uEmail,
                    date: serverTimestamp(),
                    dateN: secs,
                    postId: "",
                });

            }

            //add them to my contact list
            await setDoc(doc(db, "UserContact", auth.currentUser.uid, "Contact", sessionStorage.getItem("otherId")), {
                userId: sessionStorage.getItem("otherId"),
                fullName: this.fullName,
                userName: this.userName,
                profilePic: this.profilePic,
                userType: this.userType,
            });

            //add me to their contact list
            await setDoc(doc(db, "UserContact", sessionStorage.getItem("otherId"), "Contact", auth.currentUser.uid), {
                userId: auth.currentUser.uid,
                fullName: sessionStorage.getItem("fullName"),
                userName: sessionStorage.getItem("userName"),
                profilePic: sessionStorage.getItem("profilePic"),
                userType: sessionStorage.getItem("userType"),
            });

            //update admin subList
            const adminRef = doc(db, "AdminInfo", "info");
            await updateDoc(adminRef, {
                subList: arrayUnion(auth.currentUser.uid)
            });

            //delete expired sub
            if(sessionStorage.getItem("expiredSubId") != null && sessionStorage.getItem("expiredSubId") != ""){

                await deleteDoc(doc(db, "UserSubsE", auth.currentUser.uid, "SubsE", sessionStorage.getItem("expiredSubId")));

            }

            axios.post('https://api.baesnap.com/v1/new-sub-mail', {
                toName: this.fullName,
                toEmail: this.email,
                username: "@" + sessionStorage.getItem("userName"),
                amount: Number(this.cPrice).toLocaleString("us-Us"),
                duration: this.cDays,
            })
            .then(function (response) {
                console.log(response);

            })

            //check ref endDate
            let dateJoinedMili = Number(this.dateJoined) * 1000;
            let todayMili = Timestamp.now().seconds * 1000;

            let refDays = Math.round((todayMili - dateJoinedMili) / (1000 * 60 * 60 * 24));

            if(Number(refDays) < 365 && this.upline != ""){

                //update upline ref balance
                let mRefCut = this.refCut/100;
                let refAmount = this.cPrice * mRefCut;

                const usersRef = doc(db, "Users", this.uplineUserId);
                await updateDoc(usersRef, {
                    
                    refBalance: increment(refAmount),
                    
                });

                //update upline ref user
                const refUserRef = doc(db, "Referrals", sessionStorage.getItem("otherId"));
                await updateDoc(refUserRef, {
                    
                    refBalance: increment(refAmount),
                    
                });

                let mSecs = Timestamp.now().seconds;
                let secs = 10000000000 / mSecs;
                
                //update upline refTrans
                await addDoc(collection(db, "RefTrans"), {
                    type: "Deposit",
                    refAmount: refAmount,

                    userName: this.userName,
                    profilePic: this.profilePic,
                    email: this.email,
                    userType: this.userType,
                    sexuality: this.sexuality,
                    userId: sessionStorage.getItem("otherId"),
                    timeStamp: serverTimestamp(),
                    timeStampN: secs,

                    status: "successful",
                    ownerId: this.uplineUserId
                });

            }

            this.successText = "Successfully Subscribed to @" + this.userName + " for " + this.cDays + " days";
            this.$refs.successModal.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

            },

        }
        
    }

</script>